/**
 * Opgaveoversigt-versioner (api.schools.task_overviews.create, bulk_create, index)
 *
 * Klienten sender kun school_id, school_year_id, user_id(s), title — snapshot bygges på serveren.
 *
 * For korrekt visning af DK-vægtet forberedelse (deactivatePools + per-opgave preparation) bør
 * et versions-objekts overview indeholde:
 * - overview.school_custom_data.deactivatePools som boolean (ved manglende/undefined bruger
 *   TaskOverviewUser live schoolSettings.deactivatePools)
 * - overview.tasks med preparation på undervisningsbrikker og forberedelsesopgaver hvor faktor er sat
 * - overview.school_custom_data.prepFactor valgfri kopi af skolens faktor ved gem (til print uden
 *   kun at stole på live store; ellers bruges Vuex schoolSettings.prepFactor)
 *
 * Hvis deactivatePools mangler i snapshot, faldt visningen tidligere tilbage til overview.pools
 * (server-aggregat, ofte gammel én-faktor logik).
 */

export function effectiveDeactivatePoolsFromVersion (version, schoolSettings) {
  const scd = version && version.overview && version.overview.school_custom_data
  if (scd && typeof scd.deactivatePools === 'boolean') {
    return scd.deactivatePools
  }
  return !!(schoolSettings && schoolSettings.deactivatePools)
}

export {effectiveAssignedPoolFromNormWhenPoolsDeactivated} from './assignedPoolWhenPoolsDeactivated'

export function effectivePrepFactorFromVersion (version, schoolSettings) {
  const scd = version && version.overview && version.overview.school_custom_data
  if (scd && scd.prepFactor !== undefined && scd.prepFactor !== null && scd.prepFactor !== '') {
    return scd.prepFactor
  }
  if (schoolSettings && schoolSettings.prepFactor !== undefined && schoolSettings.prepFactor !== null && schoolSettings.prepFactor !== '') {
    return schoolSettings.prepFactor
  }
  return null
}



// WEBPACK FOOTER //
// ./src/utils/taskOverviewSnapshot.js